// extracted by mini-css-extract-plugin
export var centerError = "components-data-__Error-module___centerError";